"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/GTFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_96)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_96`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H6V24H-6V0ZM18 0H30V24H18V0Z",
					fill: "#338AF3"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.965 12.7228C12.9533 12.7228 13.7545 11.9216 13.7545 10.9333C13.7545 9.94503 12.9533 9.14386 11.965 9.14386C10.9767 9.14386 10.1755 9.94503 10.1755 10.9333C10.1755 11.9216 10.9767 12.7228 11.965 12.7228Z",
					fill: "#DCC26D"
				}),
				/* @__PURE__ */ n("path", {
					d: "M7.62817 10.9404C7.62817 12.4912 8.45624 13.9228 9.78958 14.6948C10.2036 14.9333 10.7369 14.793 10.9755 14.379C11.2141 13.9649 11.0738 13.4316 10.6598 13.193C9.85274 12.7298 9.36151 11.8667 9.36151 10.9404C9.36151 10.4632 8.97554 10.0702 8.49133 10.0702C8.00712 10.0702 7.62817 10.4562 7.62817 10.9404ZM14.3019 14.5965C15.551 13.7965 16.3089 12.4211 16.3019 10.9404C16.3019 10.4632 15.9159 10.0702 15.4317 10.0702C14.9545 10.0702 14.5615 10.4562 14.5615 10.9404C14.5615 11.8316 14.1054 12.6597 13.3615 13.1369C12.9545 13.3895 12.8212 13.9228 13.0738 14.3298C13.3264 14.7369 13.8598 14.8702 14.2668 14.6176C14.2808 14.6105 14.2878 14.6035 14.3019 14.5965Z",
					fill: "#628A40"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_96`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as GTFlag };
